import { useNavigate } from "react-router-dom";
import { useFetch, timeAgo } from "@/lib/shieldx";
import { PageHeader, Loader } from "@/components/shieldx/Primitives";
import { StatusBadge, RiskBadge, DemoTag } from "@/components/shieldx/Badges";
import { Table } from "@/components/shieldx/Table";
import { Siren, ChevronRight } from "lucide-react";

export default function Incidents() {
  const { data, loading } = useFetch("/incidents");
  const navigate = useNavigate();
  if (loading || !data) return <Loader label="Loading incidents" />;
  const sorted = [...data].sort((a, b) => (b.created_at || "").localeCompare(a.created_at || ""));

  const columns = [
    { key: "incident_id", label: "ID", render: (r) => <span className="font-mono text-xs text-slate-400">{r.incident_id}</span> },
    { key: "title", label: "Incident", render: (r) => (
      <div><p className="font-medium text-slate-100">{r.title}</p><p className="font-mono text-[11px] text-slate-500">{r.category} · {r.target_asset}</p></div>
    ) },
    { key: "source_ip", label: "Source", render: (r) => <span className="font-mono text-xs text-slate-300">{r.source_ip}</span> },
    { key: "risk_level", label: "Risk", render: (r) => <RiskBadge value={r.risk_level} /> },
    { key: "state", label: "State", render: (r) => <StatusBadge value={r.state} /> },
    { key: "created_at", label: "Opened", render: (r) => <span className="text-xs text-slate-500">{timeAgo(r.created_at)}</span> },
    { key: "go", label: "", render: () => <ChevronRight className="h-4 w-4 text-slate-600" /> },
  ];

  return (
    <div>
      <PageHeader icon={Siren} title="Incident Command Center"
        subtitle="SOC-style workspace with timelines, evidence and automated containment. Open any incident for full detail and analysis." actions={<DemoTag />} />
      <Table columns={columns} rows={sorted} testid="incidents-table" onRowClick={(r) => navigate(`/app/incidents/${r.id}`)} />
    </div>
  );
}
